let shouldShow = (roles, user) => {
  if (!roles) return true;
  for (let role of roles) {
    if (user[role]) {
      return true;
    }
  }
  return false;
}

export default shouldShow;



// WEBPACK FOOTER //
// ./src/utils/shouldShow.js